import "core-js/modules/es.promise.js";
const _excluded = ["life"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useTransition, a } from '@isyc-react/animation/lib';
import clsx from 'clsx';
import { defaultNotificationLife, defaultNotificationPersist, defaultNotificationType, NotificationItemType } from "./notification-hub.vm";
import '@isyc-react/design/main';
import "./notification-hub.style.scss";
export const NotificationHub = props => {
  const {
    config = {
      tension: 125,
      friction: 20,
      precision: 0.1
    },
    life = defaultNotificationLife,
    persist = defaultNotificationPersist,
    items,
    onChange,
    className
  } = props;
  const refMap = React.useMemo(() => new WeakMap(), []);
  const cancelMap = React.useMemo(() => new WeakMap(), []);
  const remove = React.useCallback(item => {
    onChange(state => state.filter(i => {
      return i.key !== item.key;
    }));
  }, [onChange]);
  const transitions = useTransition(items, {
    from: {
      opacity: 0,
      height: 0,
      marginTop: 0,
      life: '100%'
    },
    keys: item => item.key,
    enter: item => /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (next, cancel) {
        cancelMap.set(item, cancel);
        yield next({
          opacity: 1,
          height: refMap.get(item).offsetHeight,
          marginTop: 10
        });
        yield next({
          life: '0%'
        });
      });
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(),
    leave: [{
      opacity: 0
    }, {
      height: 0,
      marginTop: 0
    }],
    onRest: (result, ctrl, item) => {
      var _item$persist;
      const keep = (_item$persist = item.persist) !== null && _item$persist !== void 0 ? _item$persist : persist;
      if (!keep) remove(item);
    },
    config: (item, index, phase) => key => {
      var _item$life;
      return phase === 'enter' && key === 'life' ? {
        duration: (_item$life = item.life) !== null && _item$life !== void 0 ? _item$life : life
      } : config;
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('toast-react-container', className)
  }, transitions((_ref2, item) => {
    var _item$persist2;
    let {
        life
      } = _ref2,
      style = _objectWithoutProperties(_ref2, _excluded);
    const {
      type = defaultNotificationType
    } = item;
    return /*#__PURE__*/React.createElement(a.div, {
      className: clsx('notification-item', `notification-item-${type}`, item.className),
      style: style,
      role: type === NotificationItemType.ERROR ? 'alert' : 'status',
      "aria-live": type === NotificationItemType.ERROR ? 'assertive' : 'polite',
      "aria-atomic": "true"
    }, /*#__PURE__*/React.createElement("div", {
      className: "notification-message",
      ref: ref => ref && refMap.set(item, ref)
    }, !((_item$persist2 = item.persist) !== null && _item$persist2 !== void 0 ? _item$persist2 : persist) && /*#__PURE__*/React.createElement(a.div, {
      className: "notification-life",
      style: {
        right: life
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, type !== NotificationItemType.STANDARD && /*#__PURE__*/React.createElement("i", {
      className: clsx('notification-icon mdi', {
        'mdi-check-circle': type === NotificationItemType.SUCCESS,
        'mdi-close-circle': type === NotificationItemType.ERROR,
        'mdi-alert': type === NotificationItemType.WARNING,
        'mdi-alert-circle': type === NotificationItemType.INFO
      })
    }), /*#__PURE__*/React.createElement("span", null, item.message)), /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-close",
      role: "button",
      onClick: e => {
        var _item$persist3;
        e.stopPropagation();
        const keep = (_item$persist3 = item.persist) !== null && _item$persist3 !== void 0 ? _item$persist3 : persist;
        if (!keep) {
          if (cancelMap.has(item) && life.get() !== '0%') cancelMap.get(item)();
        } else remove(item);
      }
    })));
  }));
};